import { useEffect, useRef, useState } from "react";
import { INBOX_ROW_EXIT_MS } from "@/lib/mail/inboxRowExit";
import { cn } from "@/lib/cn";

type Props = {
  exiting?: boolean;
  children: React.ReactNode;
};

/**
 * Enveloppe une ligne INBOX pour une sortie fluide (slide + fondu + repli hauteur).
 * Le parent retire le message de la liste après INBOX_ROW_EXIT_MS.
 */
export function InboxMessageRowExitWrap({ exiting = false, children }: Props) {
  const wrapRef = useRef<HTMLDivElement>(null);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (!exiting) {
      setAnimating(false);
      return;
    }

    const el = wrapRef.current;
    if (!el) return;

    el.style.setProperty("--mail-row-exit-height", `${el.offsetHeight}px`);
    el.style.setProperty("--mail-row-exit-duration", `${INBOX_ROW_EXIT_MS}ms`);
    setAnimating(false);

    let raf2 = 0;
    const raf1 = window.requestAnimationFrame(() => {
      raf2 = window.requestAnimationFrame(() => setAnimating(true));
    });

    return () => {
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
    };
  }, [exiting]);

  return (
    <div
      ref={wrapRef}
      className={cn("mail-inbox-row-exit-wrap overflow-hidden", animating && "mail-inbox-row-exit-wrap--active")}
    >
      <div className={cn("mail-inbox-row-exit-inner", animating && "mail-inbox-row-exit-inner--active")}>
        {children}
      </div>
    </div>
  );
}
